import {
  GET_SCOPES_REQUEST,
  GET_SCOPES_SUCCESS,
  GET_SCOPES_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: true,
    data: [],
    error: false,
  };
};

const initialState = getInitialState();

const scopes = (state = initialState, action) => {
  const types = {
    [GET_SCOPES_REQUEST]: () => ({
      ...state,
      isLoading: true,
      error: false,
    }),
    [GET_SCOPES_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      data: action.response,
      error: false,
    }),
    [GET_SCOPES_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default scopes;
